import { render } from "./SecurityOfficersView.vue?vue&type=template&id=9589c766&scoped=true"
import script from "./SecurityOfficersView.vue?vue&type=script&lang=js"
export * from "./SecurityOfficersView.vue?vue&type=script&lang=js"

import "./SecurityOfficersView.vue?vue&type=style&index=0&id=9589c766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9589c766"]])

export default __exports__